import { useEffect, useState } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Toolbar } from "primereact/toolbar";
import { Button } from "primereact/button";
import { EmptyWorkStreamCategory, IModel, IWorkStreamCategory,} from "./WorkStreamCategories";
import { ILogin } from "../../../models/Login";
import { Fetch } from "../../../shared/Fetch";
import { safeFormatDate } from "../../../models/DateFormatMapper";
import { RoleMapping } from "./RoleMapping";


interface IProps {
    toast: any;
    reload: boolean;
    setModal: (modal: IModel) => void;
}

export const Table = (props: IProps) => {

    const loginObj: ILogin = JSON.parse(sessionStorage.getItem("auth") + "");
    const DateFormat = loginObj.date_Format;
    const [tableData, setTableData] = useState<{  tableData: IWorkStreamCategory[]; loading: boolean; }>({  tableData: [],  loading: false,});
    const [roleModal, setRoleModal] = useState({ open: false, singleData: {} as IWorkStreamCategory});

    const loadData = async () => {

        try {
            setTableData((prev) => ({ ...prev, loading: true, }));
            const response = await Fetch( "TenderWorkstream/GetWorkStreamCategory",  "GET", null, null,  props.toast  );
            if (response?.ok) {
              const data = await response.json();
                setTableData({ tableData: data,  loading: false,  });
            }

        } finally {
            setTableData((prev) => ({ ...prev, loading: false, }));
        }
    };

    useEffect(() => {
        loadData();
    }, [props.reload]);

    const openNew = () => {
        props.setModal({ open: true, singleData: EmptyWorkStreamCategory,  });
    };

    const leftToolbarTemplate = () => (
        <Button label="New" icon="pi pi-plus" className="p-button-success" onClick={openNew} />
    );

    const actionBody = (rowData: IWorkStreamCategory) => (
        <div className="flex gap-2">
            <Button  icon="pi pi-pencil"  className="p-button-rounded p-button-text" onClick={() => props.setModal({  open: true,  singleData: rowData,  }) } />
           <Button icon="pi pi-user" className="p-button-rounded p-button-text p-button-success" onClick={() => setRoleModal({ open: true,singleData: rowData}) }/>
        </div>
    );

    return (
        <>
            <Toolbar left={leftToolbarTemplate}className="mb-3" />
            <DataTable value={tableData.tableData} loading={tableData.loading} stripedRows showGridlines size="small"
                responsiveLayout="scroll" header="Work Stream Category List"
            >
                <Column header="SN."  body={(rowData, options) => options.rowIndex + 1} />
                <Column  field="category_Name"  header="Category Name"  />
                <Column  field="added_By"  header="Added By"  />
                <Column field="added_On"  header="Added On"  body={(rowData) => safeFormatDate( rowData.added_On,  "dd/MM/yyyy", DateFormat )} />
                <Column field="updated_By" header="Updated By" />
                <Column field="updated_On" header="Updated On"  body={(rowData) => safeFormatDate( rowData.updated_On,  "dd/MM/yyyy", DateFormat ) } />
                <Column header="Actions" body={actionBody} style={{ width: "120px" }} />
            </DataTable>
            <RoleMapping open={roleModal.open} singleData={roleModal.singleData} toast={props.toast} onHide={() =>  setRoleModal({ open: false,  singleData: {} as IWorkStreamCategory })}/>
        </>
    );
};

export default Table;

